/* eslint-disable global-require */
// import './wdyr';

import { applyPolyfills, defineCustomElements } from '@tag/tag-components-v3/loader';
import {
  applyPolyfills as applyPolyfills_v4,
  defineCustomElements as defineCustomElements_v4
} from '@tag/tag-components-v4/loader';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import ReactDOM from 'react-dom/client';

import { REACT_ROOT_ID } from './config/common.config';
import ProvidersWrapper from './ProvidersWrapper';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@access-erp/ui-components/styles.css';
import '@/assets/styles/styles.scss';

// EVO Design System Fonts (Inter, JetBrains Mono, Source Serif 4)
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/600.css';

// EVO Design System Tailwind CSS (scoped to .evo-wrapper)
import '@/styles/evo-tailwind.css';

//@ts-ignore
import requirejs from '@/assets/libs/requirejs';
//@ts-ignore
window.requirejs = requirejs;

// Tag Components Initialization
applyPolyfills().then(() => {
  defineCustomElements(window);
});

applyPolyfills_v4().then(() => {
  defineCustomElements_v4();
});

// Test pipeline comment

// Plugin for parse custom date formats
dayjs.extend(customParseFormat);
// Plugin for compare dates
dayjs.extend(isSameOrAfter);

const container = document.getElementById(REACT_ROOT_ID);
const root = ReactDOM.createRoot(container!);

root.render(<ProvidersWrapper />);


